import { useEffect, useState } from "react";
import { api, openSecureFile, markSectionSeen } from "../lib/api";
import { Card } from "../components/ui/card";
import { FolderArchive, FileText, Download } from "lucide-react";


// Iter122as · pagina "Documenti del condominio": la sezione Moduli è stata spostata
// nella Bacheca (tab "Moduli"). Qui restano solo i documenti resi consultabili dallo Studio.
export default function DocumentiCondominio() {
  const [documenti, setDocumenti] = useState(null);

  useEffect(() => {
    api.get("/condomino/documenti").then((r) => setDocumenti(r.data.documenti)).catch(() => setDocumenti([]));
    // Iter122au · azzera badge sidebar "documenti" appena l'utente entra
    markSectionSeen("documenti");
  }, []);

  const cats = [...new Set((documenti || []).map((d) => d.categoria))];

  return (
    <div className="max-w-3xl space-y-5" data-testid="documenti-condominio-page">
      <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight flex items-center gap-3">
        <FolderArchive className="w-9 h-9 text-brand" /> Documenti del condominio
      </h1>

      <Card className="p-4 border-2" data-testid="documenti-card">
        <h2 className="font-display text-xl font-bold text-brand mb-1">Documenti del condominio</h2>
        <p className="text-sm text-slate-500 mb-3">I documenti del tuo stabile che lo Studio ha reso consultabili (verbali, regolamento, certificazioni…).</p>
        {!documenti && <div className="text-slate-500">Caricamento…</div>}
        {documenti && documenti.length === 0 && (
          <div className="text-slate-500 text-sm" data-testid="documenti-vuoto">Nessun documento disponibile al momento.</div>
        )}
        {cats.map((cat) => (
          <div key={cat} className="mb-3">
            <div className="text-xs font-bold uppercase tracking-wide text-slate-400 mb-1.5">{cat}</div>
            <div className="space-y-2">
              {documenti.filter((d) => d.categoria === cat).map((d) => (
                <div key={d.id} className="p-3 rounded-lg border border-slate-200 flex flex-wrap items-center gap-2" data-testid={`doc-cond-${d.id}`}>
                  <FileText className="w-4 h-4 text-brand shrink-0" />
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-sm break-words">{d.documento}</div>
                    {d.file_name && <div className="text-xs text-slate-500 break-all">{d.file_name}</div>}
                    {d.data_aggiornamento && <div className="text-xs text-slate-400">Aggiornato: {new Date(d.data_aggiornamento).toLocaleDateString("it-IT")}</div>}
                  </div>
                  {d.file_id && (
                    <button className="h-8 px-3 text-xs bg-slate-100 hover:bg-slate-200 rounded-lg inline-flex items-center gap-1"
                      onClick={() => openSecureFile(`/files/${d.file_id}`)} data-testid={`doc-download-${d.id}`}>
                      <Download className="w-3.5 h-3.5" /> Scarica
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </Card>

      <div className="text-xs text-slate-400 text-center">
        I moduli da compilare sono ora disponibili nella sezione <b>Bacheca → Moduli</b>.
      </div>
    </div>
  );
}
